import { createContext, useContext } from "react";

import { InboxScreenHelper } from "./InboxScreenHelper.ts";

export const InboxScreenContext = createContext<InboxScreenHelper>(
  {} as InboxScreenHelper
);

export const useInboxScreenContext = () => useContext(InboxScreenContext);
